export default __webpack_public_path__ + "static/media/ad-youfoodz.56bc4117.png";